
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import { Cliente } from '@/__env/lib/Clientes';
    import { Wait } from '@/__env/ext';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        Estado: 'ok' | 'cargando' | 'error' = 'cargando';
        @Watch( 'Estado' )
        onEstado()
        {
            this.$emit( 'estado', this.Estado );
        }

        public Cliente: Cliente = new Cliente();
        public HayCambios: boolean = false;
        async mounted()
        {
            while ( document.getElementById( 'row-form' ) == null )
            {
                await Wait( 200 );
            }

            for ( let inpu of document.getElementById( 'row-form' ).getElementsByTagName( 'input' ) )
            {
                inpu.addEventListener( 'input', ( event: any ) => { this.HayCambios = true; } );
            }

            this.Iniciar();
        }

        async Iniciar()
        {
            this.Estado = 'cargando';

            await Wait( 100 );
            this.Cliente = await Cliente.create( this.Pedido.Cliente.Id );

            this.Estado = 'ok';
            this.HayCambios = false;

            this.$nextTick( () =>
            {
                document.getElementById( 'primer-input' ).getElementsByTagName( 'input' )[0].focus();
            } );
        }

        async Guardar()
        {
            this.Estado = 'cargando';
            let e = await this.Cliente.save();
            if ( e )
            {
                this.Estado = 'ok';
                this.Pedido.Cliente = this.Cliente;
                this.Controlador.Vista.Modo = 'resumen';
                this.$EventBus.Notificaciones.Completado( 'Guardado correctamente' );
            }
            else
            {
                this.Estado = 'ok';
                this.$EventBus.Notificaciones.Error( 'Error al guardar' );
            }
        }

        async Cancelar()
        {
            //this.Iniciar();
            this.Controlador.Vista.Modo = 'resumen';
        }


    }
